import { Component, Inject, OnInit, ViewChild, AfterViewInit, ElementRef } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import { Subscription } from "rxjs";

import { AlertService, MediaWatcherService } from "../../_services";
import { AppGlobals } from "../../app.globals";

@Component({
    selector: "identity-document-help-dialog",
    templateUrl: "profileImageHelpDialog.component.html",
    styleUrls: ["profileImageHelpDialog.component.css"],
})

export class ProfileImageHelpDialogComponent implements OnInit, AfterViewInit {
    isMobilePortrait = false;
    mediaWatcherSubscription: Subscription;
    isProfileImage = false;
    isMobile = false;

    constructor(private dialogRef: MatDialogRef<ProfileImageHelpDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any, private alertService: AlertService, private appGlobals: AppGlobals,
        private mediaWatcherService: MediaWatcherService) {
    }

    ngAfterViewInit() {
    }

    ngOnInit() {
        this.mediaWatcherSubscription = this.mediaWatcherService.isMobilePortrait.subscribe(isMobilePortrait => {
            this.isMobilePortrait = isMobilePortrait;
        });

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;

           
        });
    }

    close() {
        this.dialogRef.close();
    }

}